import React, { useEffect, useRef, useState } from 'react';


// Evidenziazione della variazione di quota. Prima veniva pilotata da un setTimeout per cella
// (mai ripulito, quindi con accumulo di timer e aggiornamenti su componenti gia' smontati) che
// impostava la classe "quota-flash", inesistente in tutti i CSS del progetto: la freccia non
// veniva quindi mai rimossa. Ora l'evidenziazione si spegne da sola via animazione CSS.
const MarcatoreQuotaTabella = (props) => {
    const { quota } = props;
    const [variazione, setVariazione] = useState(null);
    const prevQuota = useRef(undefined);
    // cambia ad ogni variazione: serve come key per far ripartire l'animazione CSS
    const [contatoreVariazioni, setContatoreVariazioni] = useState(0);

    useEffect(() => {
        const precedente = prevQuota.current;
        prevQuota.current = quota;
        if (precedente !== undefined && precedente !== quota && quota > 1) {
            setVariazione(parseFloat(precedente) > parseFloat(quota) ? 'giu' : 'su');
            setContatoreVariazioni((valore) => valore + 1);
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [quota]);

    return (
        <>
            <div
                key={contatoreVariazioni}
                className={"position-relative" + (variazione ? " quota-variata" : "")}
            >
                <i
                    className={"position-absolute " + (variazione === 'giu'
                        ? 'bi bi-arrow-down text-danger'
                        : (variazione === 'su' ? 'bi bi-arrow-up text-success' : ''))}
                    style={{left: "5px", top: "-1px"}}
                ></i>
                {quota > 1 ? parseFloat(quota).toFixed(2) : '-'}
            </div>
        </>
    );
}

export default React.memo(MarcatoreQuotaTabella);
